import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface TransparentCardProps {
  /** Content to display inside the card */
  children: React.ReactNode;
  /** Additional classes to apply to the card */
  className?: string;
  /** URL or imported image file for the background */
  backgroundImage: string | { src: string };
  /** Opacity of the blue overlay (0-100) */
  opacity?: number;
  /** Scale factor for the background image (1 = original size) */
  scale?: number;
}

/**
 * TransparentCard component that creates a card with a semi-transparent blue overlay
 */
export function TransparentCard({ 
  children, 
  className = "",
  backgroundImage,
  scale = 1.35 // Default scale is 1.2 (20% larger)
}: TransparentCardProps) {
  // Handle both string URLs and imported image objects
  const imageUrl = typeof backgroundImage === 'string' 
    ? backgroundImage 
    : backgroundImage.src;

  return (
    <div className="relative rounded-lg overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{ 
          backgroundImage: `url(${imageUrl})`,
          transform: `scaleX(-1) scale(${scale})` // Flip horizontally and scale up
        }}
      />
      
      {/* Transparent Blue Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#00adf0_20%,#00adf0_20%,rgba(0,173,240,0.65)_100%)]"/>
      
      {/* Card Content */}
      <Card className={`relative border-0 bg-transparent shadow-none ${className} p-6`}>
        <CardContent className="z-10 relative p-0">
          {children}
        </CardContent>
      </Card>
    </div>
  );
}